/*
  _customDirectives.js

  This file holds all custom directives to be used throughout vue.js.

  To use custom directives, import what you need to each component files.

  For convention, please only use uppercase for variable name.
*/

export const FOCUS_ON_LOAD = {
  inserted(el) {
    el.focus();
  },
};

export const CLICK_OUTSIDE = {
  beforeMount(el, binding) {
    var callback = binding.value;

    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        return callback(event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },

  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};
